import Loader from 'react-loaders';
import './index.scss';
import AnimatedLetters from '../AnimatedLetters/index';
import { useState, useEffect, useRef } from 'react';
import emailjs from '@emailjs/browser';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';

const Contact = () => {
    const [letterClass, setLetterClass] = useState('text-animate');
    const form = useRef();


    useEffect(() => {
        const timer = setTimeout(() => {
            setLetterClass('text-animate-hover')
        }, 3000);
        return () => clearTimeout(timer);
    }, [])

    const sendEmail = (event) => {
        event.preventDefault()

        emailjs
            .sendForm('service_0y39fmv', 'contact_form', form.current, 'vYwdmVpx6fwH85gYY' )
            .then(
                () => {
                    alert('Message successfully sent!')
                    window.location.reload(false)
            },
            () => {
                alert('Failed to send message, please try again.')
            }
        )
    }

    

    return (
        <>
            <div className='container contact-page'>
                <div className='text-zone'>
                    <h1>
                        <AnimatedLetters 
                        letterClass={letterClass}
                        strArray={"Contact".split("")} 
                        idx={15}
                        />
                    </h1>
                    <p>Job opportunities? <br /> Project Ideas? <br /> Comments, Questions, or Concerns?</p>
                    <p style={{fontWeight: 'bold'}}>Reach out!</p>
                <div className='contact-form'>
                    <form ref={form} onSubmit={sendEmail}>
                        <ul>
                            <li className="half">
                                <input 
                                    type="text" 
                                    name="name" 
                                    placeholder="Name" 
                                    required 
                                />
                            </li>
                            <li className="half">
                                <input 
                                    type="email" 
                                    name="email" 
                                    placeholder="Email" 
                                    required 
                                    />
                            </li>
                            <li>
                                <input 
                                    placeholder="Subject"
                                    type="text"
                                    name="subject"
                                    required
                                    />
                            </li>
                            <li>
                                <textarea 
                                    placeholder="Message"
                                    name="message"
                                    required
                                ></textarea>
                            </li>
                            <li>
                                <input 
                                    type="submit"
                                    className="flat-button"
                                    value="SEND"
                                    />
                            </li>
                        </ul>
                    </form>
                </div>
                </div>
                <div className="info-map">
                    Samantha Brown,
                    <br />
                    USA,
                    <br />
                    New York Metropolitan Area
                    <br />
                    <span>SamanthaBrownCoding@Gmail.com</span>
                </div>
                <div className="map-wrap">
                <MapContainer center={[41.0376, -74.0407]} zoom={13}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Marker position={[41.0376, -74.0407]}>
              <Popup>Samantha Lives Here</Popup>
            </Marker>
          </MapContainer>

                </div>
            </div>
        <Loader type="ball-clip-rotate-multiple" />
        </>
    )
}

export default Contact;